module.exports = __webpack_public_path__ + "img/button diameter.965cd611.png";